/**
 * Mã thứ trên thực đơn rút gọn: 2 = thứ 2 … 7 = thứ 7, 8 = chủ nhật.
 * Chủ nhật không phải ngày ăn. Thứ 7 chỉ hiện khi thực đơn kéo tới thứ 7.
 */
const FRIDAY = 6;

export function lastEatingWeekDay(
  items: Array<{ weekDay?: number | null }> | null | undefined
): number {
  let last = 0;
  for (const item of items ?? []) {
    const weekDay = Number(item.weekDay);
    if (weekDay >= 2 && weekDay <= 7 && weekDay > last) last = weekDay;
  }
  return last || FRIDAY;
}

/** `Date#getDay`: 0 chủ nhật … 6 thứ 7 → mã thực đơn. */
export function menuWeekDayFromJsDay(jsDay: number): number {
  return jsDay === 0 ? 8 : jsDay + 1;
}
